import { createGlobalStyle, css } from 'styled-components';

export const GlobalStyles = createGlobalStyle<{
  noHeight: boolean;
}>`
  :root {
    --bottom-bar-height-mobile: var(--default-bottom-bar-height-mobile);
    ${({ noHeight }) =>
      noHeight &&
      css`
        --bottom-bar-height-mobile: env(safe-area-inset-bottom, 0px);
      `}
  }
`;
